/** Align with dashboard: explicit low limit, else default 5. */
export function lowStockThreshold(product) {
  const lim = Number(product?.lowStockLimit);
  return Number.isFinite(lim) && lim > 0 ? lim : 5;
}

export function isLowStock(product) {
  const q = product?.quantity !== undefined ? Number(product.quantity) : NaN;
  if (!Number.isFinite(q)) return false;
  return q <= lowStockThreshold(product);
}
